import React from "react";
import "./Work.css";

function Work() {
  return (
    <div className="work-sec">
      <br />
      <div className="container">
        <h1
          style={{
            fontFamily: "Solway",
            display: "flex",
            justifyContent: "center",
            fontSize: "40px",
          }}
        >
          <b>Work & Experience</b>
        </h1>

        <div className="line-mf"></div>
        <p className="hover-effect">
          Hover over the cards to read individually in still condition &#128516;
        </p>
        <div className="row">
          {" "}
          <div className="col-xs-6 col-sm-6">
            <div className="left-sec">
              <div className="card details">
                {" "}
                <h2 className="details-text">
                  <b>Felidaie</b>
                </h2>
                <h5 className="position-text">
                  (Product Engineer & Developer)
                </h5>
                <h6 className="details-text">From Sep 2020 - Present</h6>
                <p className="details-text">
                  {" "}
                  I was one of the first member of core engineering team where
                  my responsibilities revolved around carrying end-to-end life
                  cycle of the product from prototyping to development to it's
                  deployment.
                </p>
              </div>
            </div>
          </div>
          <div className="col-xs-6 col-sm-6">
            {" "}
            <div className="right-sec">
              {" "}
              <div className="card details">
                {" "}
                <h2 className="details-text">
                  <b>Buddy</b>
                </h2>
                <h5 className="position-text">(Founder)</h5>
                <h6 className="details-text">From Aug 2019 - June 2020</h6>
                <p className="details-text">
                  {" "}
                  After analyzing b2c market during my college days, I hopped on
                  my new venture called "Buddy" in order to bring complete
                  transparency for users . Built the prototype and got some
                  traction too.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6 col-sm-6">
            <div className="second-row-left-sec">
              <div className="card details">
                {" "}
                <h2 className="details-text">
                  <b>Rage Communications</b>
                </h2>
                <h5 className="position-text">
                  (Product management & Development Intern)
                </h5>
                <h6 className="details-text">From Jan 2019 - Apr 2019</h6>
                <p className="details-text">
                  {" "}
                  I was responsible for developing the front-end part of the
                  website in order to improve UI/UX .
                </p>
              </div>
            </div>
          </div>
          <div className="col-xs-6 col-sm-6">
            {" "}
            <div className="second-row-right-sec">
              {" "}
              <div className="card details">
                {" "}
                <h2 className="details-text">
                  <b>IBM</b>
                </h2>
                <h5 className="position-text">(Web Developer Intern)</h5>
                <h6 className="details-text">From June 2017 - Aug 2017</h6>
                <p className="details-text">
                  {" "}
                  A college level test was conducted by IBM after which I was
                  selected as a summer intern for web development internship at
                  IBM.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>{" "}
    </div>
  );
}

export default Work;

{
  /* <div className="details">
            <h2 className="details-text">Felidaie</h2>
            <h3 className="details-text">Product Engineer & Developer</h3>
            <h3 className="details-text">From Sep-2020 - Present</h3>
            <h5 className="details-text">
              {" "}
              was one of the first member of core engineering team where my
              responsibilities revolved around carrying end-to-end life cycle of
              the product from prototyping to development to it's deployment.
            </h5>
          </div> */
}
